export default function baseUrl(_url: string, _baseURL: string) {
	const isExternal = /^(f|ht)tps?:\/\//i.test(_url);
	return isExternal ? _url : _baseURL + _url;
}
